export const messages = {
  en: {
    landingPromotion: {
      desktop: "DRCT is heading to World Aviation Festival in Lisbon, 13–15 October. Visit us at stand 1-102C.",
      mobile: "Meet us at WAF Lisbon, Oct 13–15.",
      ctaLabel: "Learn more",
      dismissLabel: "Dismiss World Aviation Festival announcement"
    },
    landingNavigation: {
      toggleLabel: "Toggle navigation menu",
      mainLabel: "Main navigation"
    },
    apiMessage: "Start selling tickets with the DRCT API",
    apiDescription: "Build your travel business with a quickly integrated DRCT API. Issue tickets at unique fares without GDS fees. Explore the documentation and send the first request to get started in 5 minutes.",
    advantage_api_1: "Integration in 5 days",
    advantage_api_2: "No initial charge",
    advantage_api_3: "24/7 support",
    apiOnePlaceTitle1: "Search",
    apiOnePlaceOption1: "All necessary methods of searching for flights and pricing are available to get up-to-date information. ",
    apiOnePlaceTitle2: "Booking and issuing",
    apiOnePlaceOption2: "After a booking is made, a time limit will come up. The booking should be issued at any time before the specified time limit.",
    apiOnePlaceTitle3: "Post-sales services",
    apiOnePlaceOption3: "Void tickets and cancel bookings. Tickets exchanges and refunds are possible via our support.",
    apiOnePlaceTitle4: "Ancillaries",
    apiOnePlaceOption4: "Order any additional services from meals and seats on board to the carriage of pets. Will be available soon.",
    apiOnePlaceTitle: "All features in one app",
    apiOnePlaceDescription: "We bring together everything required to issue a ticket at the best price and accompany a customer from purchasing to boarding.",
    apiBenefitsTitle: "Developer friendly 💙",
    apiBenefitsDescription: "The DRCT API was created with love for developers. \n You don't need to figure out complex airline APIs — we have already done that for you.",
    apiBenefitTitle1: "Comprehensive documentation",
    apiBenefitDescription1: "We did our best to make the documentation clear and simple. Get started quickly with documentation, a <a target='_blank' href='https://www.postman.com/drct-api/workspace/drct-api/overview'>Postman workspace</a>, and a stable test environment.",
    apiBenefitTitle2: "Easy-to-use booking tool",
    apiBenefitDescription2: "Helps to make sure that requests are sent correctly so that flights and created bookings are displayed as they should be.",
    apiBenefitTitle3: "Support",
    apiBenefitDescription3: "Keeping our API reference accurate and easy to understand is crucial for us. If you have any questions or want to share your feedback, just contact us in the chat.",
    pageTitle: "DRCT for agencies",
    pageDescription: "Sell flights and ancillaries directly with airlines without leaving your GDS. Increase your markups thanks to the agent-oriented software and 0 ticketing fee.",
    forAgencies: "For agencies",
    forNonIataAgencies: "For Non-IATA Agencies",
    forOta: "For OTA",
    forAirlines: "For airlines",
    forDevelopers: "For developers",
    signIn: "Sign in",
    try: "Book a Demo",
    solutionsMenu: {
      label: "Solutions",
      heading: "Solutions",
      description: "Find the right DRCT solution for the way you distribute, sell or integrate airline offers.",
      airlines: {
        title: "For Airlines",
        description: "Keep fares, bundles and ancillaries intact across GDS, NDC and direct sales — without losing agent reach."
      },
      iataAgencies: {
        title: "For IATA Agencies",
        description: "Full airline content in your workflow — from booking and servicing to BSP reporting, with 24/7 support."
      },
      nonIataAgencies: {
        title: "For Non-IATA Agencies",
        description: "Issue and service airline tickets from day one — no IATA accreditation, airline contracts or GDS expertise."
      },
      ota: {
        title: "For OTAs",
        description: "Bring NDC, low-cost and charter content into your product through one normalized API — with OTA-grade L2B limits."
      }
    },
    productsMenu: {
      label: "Products",
      heading: "Products",
      description: "Choose the DRCT product for your booking, integration or servicing workflow.",
      workspace: {
        title: "Workspace",
        description: "Search, book and service full airline content in one workspace tailored to your agency."
      },
      api: {
        title: "API",
        description: "One integration for normalized airline content, competitive pricing and high L2B limits — no provider exceptions."
      },
      extension: {
        title: "Extension",
        description: "Bring full, enhanced airline content into the tools your team already uses — without changing workflows."
      }
    },
    exploreDocs: "Explore the docs",
    airlinesMessage: "Bringing airlines closer to passengers",
    airlinesDescription: "DRCT is a tech provider building a new era Uber-like distribution platform to unite carriers and passengers in a solid eco-system delivering a unique shopping experience.",
    airlinesAdvantage1: "Launching in 2-4 weeks",
    airlinesAdvantage2: "Low-cost distribution",
    airlinesAdvantage3: "24/7 support",
    airlinesCostsTitle: "Reducing costs 📉",
    airlinesCostsDescription: "The DRCT's goal is to make airline distribution more efficient — simple, personalised, and low-cost. We focus on technology so that airlines can focus on the product.",
    airlinesCostsBenefit1Title: "On reaching new markets and customers",
    airlinesCostsBenefit1Desc: "Business development in non-domestic markets is always a challenge for airlines. Especially in markets where the market share of the airline is low. Payment collection and contracting are expensive. \n \nDRCT is integrated with GDSs, payment getaways, and represented by global GSAs and all main markets. Using existing connectivities we make it possible to sell tickets via GDS on any market and accept payments via BSP or credit card with no hustle or GDS fees.",
    airlinesCostsBenefit2Title: "On supporting of own OBT and API",
    airlinesCostsBenefit2Desc: "Developing and supporting your own OBT is expensive and isn’t effective. It’s almost impossible to force sellers to use OBTs of different airlines for flight searches. Delivering and supporting your own API or OBT is also a challenge — implementation slots, certification, support, and contracting. All this means that the airline spends resources on technical staff instead of developing its business. \n \nDRCT delivers content to the seller via API or OBT. Integrated with hundreds of sellers our team clearly understands the requirements of any type of seller — TMCs, OTAs, Traditional Agencies. DRCT already has integration with mid- and back-office systems, so implementation of DRCT solutions is the easiest way to get content from all needed airlines without the need to implement each airline’s OBT or API.",
    airlinesRevenuesTitle: "Increase revenues 📈",
    airlinesRevenuesDescription: "The airline business is low-margin. Using modern technology and access to markets, DRCT provides opportunities for revenue and margin growth.",
    airlinesRevenuesBenefit1Title: "By expanding the network",
    airlinesRevenuesBenefit1Desc: "The traditional airline business model of building its own network and distribution via GDS — is no longer in demand. The point-to-point model with direct distribution channels is taking over. But it also has shortcomings. The absence of transit passengers and limited distribution makes this model barely scalable. \n \nDRCT is an aggregator for many airlines, we are also connected to most CRSs and all GDSs. It makes it possible to establish partnerships quickly and easily with no changes required to business models and pricing structures. We also effectively deliver this content to sellers all over the world.",
    airlinesRevenuesBenefit2Title: "Using deep data analysis and personalisation to sell more",
    airlinesRevenuesBenefit2Desc: "While distributing, airlines can get a piece of very limited information about flight requests. In most cases, it’s just an anonymous pricing request and booking. Lack of information about who is asking, and actual competitor’s offers make the creation of data-driven offers impossible. \n \nDRCT receives loads of information directly from the seller at the moment of request. In most cases, we know who is searching for the flight, previous buying history, and offers from all airlines that are proposed to the passenger. It gives us a unique advantage to create personalised offers that will perfectly fit passenger expectations.",
    footerPrivacy: "Privacy policy",
    footerWebsiteTerms: "Website terms of use",
    footerExtensionTerms: "Extension terms of use",
    home: {
      pageTitle: "DRCT. NDC Aggregation Platform for Travel Agencies",
      pageDescription: "DRCT orchestrates airline offers across GDS, NDC, direct and low-cost channels through one unified distribution layer for travel sellers.",
      hero: {
        title: "We adapt and activate airline offers across diverse travel audiences",
      subtitle: "DRCT — one orchestration layer for your distribution, from IATA agencies to OTAs and Super Apps",
        description: "Airlines gain full control over how their offers reach the market. Travel sellers get seamless access to direct airline inventory — delivered via NDC and other custom distribution schemes — without needing separate integrations for each source. Agencies can continue working within their existing GDS workflows and interfaces. One platform connecting both sides, without fragmentation.",
        ctaLabel: "Book a Demo",
        chipIataAgencies: "IATA Agencies",
        chipOta: "OTA",
        chipNonIataAgencies: "Non-IATA Agencies",
        chipTmc: "TMC",
        chipSuperApps: "Super Apps",
        chipTravelTechStartups: "Travel Tech Startups"
      },
      gain: {
        heading: "Problems we solve",
        description: "DRCT addresses structural inefficiencies on both sides of airline distribution.",
        tabSellers: "For Travel Sellers",
        tabAirlines: "For Airlines",
        airlineCard1Title: "Full control over presentation",
        airlineCard1Desc: "Your offer structure reaches every agent and OTA exactly as you define it — fares, bundles, and ancillaries, consistently across all channels.",
        airlineCard2Title: "Better economics at scale",
        airlineCard2Desc: "Direct distribution and a gradual shift toward NDC lower cost-per-booking without sacrificing reach or agent coverage.",
        airlineCard3Title: "Adoption inside familiar tools",
        airlineCard3Desc: "NDC content surfaces within the GDS interfaces agents already use. No new systems, no retraining — adoption happens naturally.",
        airlineCard4Title: "One layer for both channels",
        airlineCard4Desc: "GDS and NDC coexist in a single distribution layer — managed, reported, and settled in one place instead of two parallel systems.",
        sellerCard1Title: "All content, one connection",
        sellerCard1Desc: "GDS, NDC, and direct airline content unified into a single normalized layer — one integration, complete coverage across all sources.",
        sellerCard2Title: "One workflow, one interface",
        sellerCard2Desc: "Search, book, issue, and service every source from a single interface — no separate logins, no format reconciliation.",
        sellerCard3Title: "NDC access without friction",
        sellerCard3Desc: "NDC fares and direct airline offers without per-airline accreditation or new contracts — through the workflows you already use.",
        sellerCard4Title: "Unified post-booking servicing",
        sellerCard4Desc: "Changes, exchanges, refunds, and voids handled through one order layer — normalized across all connected airlines."
      },
      flow: {
        heading: "How the ecosystem works",
        description: "A structured distribution flow — from raw offers to seller-ready solutions, powered by DRCT.",
        sourceEyebrow: "Airline offer",
        sourceHeading: "Original form",
        sourceItem1: "GDS",
        sourceItem2: "NDC",
        sourceItem3: "Custom distribution schemes",
        coreEyebrow: "Orchestration layer",
        coreHeading: "Adapt. Enhance. Activate.",
        pipeline1: "Normalization — unified format",
        pipeline2: "Enhancement — bundles, upsell, context-aware recommendations",
        pipeline3: "Fulfillment — end-to-end lifecycle across NDC, custom APIs, GDS",
        coreNote: "One unified experience across all sources",
        destEyebrow: "Seller",
        destHeading: "Seller-ready",
        destItem1: "Agency",
        destItem2: "OTA, Super App",
        destItem3: "TMC",
        step1Heading: "Full content access",
        step1Desc: "Complete airline content from multiple sources, unified into a single distribution layer.",
        step2Heading: "Enhancement",
        step2Desc: "The offer is enriched with additional capabilities: virtual interlining, branded fares and ancillaries, pricing and tariff logic, back-office and mid-office integrations.",
        step3Heading: "Audience fit",
        step3Desc: "Offers adapted for each distribution channel and audience, ensuring relevance and usability across different travel sellers.",
        step4Heading: "Training and support 24/7",
        step4Desc: "Continuous enablement for partners — onboarding, training, and operational support across all distribution workflows."
      },
      network: {
        liveTitle: "+50 airlines in LIVE",
        liveAlt: "+50 airlines live on network",
        moreComingTitle: "More Airlines Coming",
        moreComingAlt: "More airlines coming",
        heading: "Leading carriers. One connection.",
        description: "Access direct, normalized offers from leading airlines through a single integration — full content, consistent terms, no per-carrier contracts.",
        liveLabel: "Live on network",
        moreComingLabel: "More coming",
        certHeading: "ARM System Provider certified by IATA",
        certDescriptionBefore: "More information at",
        certLinkLabel: "IATA ARM index registry"
      },
      metrics: {
        title: "DRCT by the numbers",
        value1: "50",
        suffix1: "+",
        label1: "Connected Airlines",
        desc1: "Full-service and low-cost carriers live on the network.",
        value2: "4,000",
        suffix2: "+",
        label2: "Travel Sellers",
        desc2: "Individual agents across TMCs, OTAs, and API partners globally.",
        value3: "500",
        suffix3: "+",
        label3: "Agency Partners",
        desc3: "TMCs, OTAs, and travel agencies across Europe, the U.K., and the U.S."
      },
      why: {
        heading: "Why DRCT",
        description: "The case for a unified airline distribution platform — in plain terms.",
        item1Title: "One platform for GDS and NDC together",
        item1Desc: "Hybrid distribution without managing two parallel systems. NDC and GDS content coexist, consistently delivered to every seller.",
        item2Title: "No system switching",
        item2Desc: "Airlines manage distribution in one place. Sellers book, change, and service in one place. The full workflow lives inside DRCT platform.",
        item3Title: "Beyond a traditional airline aggregator",
        item3Desc: "DRCT enhances offers — adding ancillaries, building bundles, and assembling multi-airline itineraries. Content arrives at the seller better than it left the airline.",
        item4Title: "NDC access without the friction",
        item4Desc: "Sellers get NDC fares and airline content through familiar interfaces. No new accreditation, no separate NDC onboarding per airline.",
        item5Title: "A transition layer, not a disruption",
        item5Desc: "Airlines moving from GDS toward NDC use DRCT to manage the shift gradually — maintaining full coverage while growing direct channel volume.",
        item6Title: "Every seller type covered",
        item6Desc: "IATA agencies, non-IATA agents, OTAs, TMCs, and Super Apps — all reached through the same distribution platform.",
        wideTitle: "24/7 operational support",
        wideDesc: "Distribution issues, booking failures, and escalations handled by DRCT's own team — for airlines and sellers alike."
      },
      testi: {
        slide1Quote: "Partnering with DRCT allows us to reach a broader network of travel sellers with our NDC content, while keeping the booking experience consistent and reliable.",
        slide1Name: "Jane Doe",
        slide1Role: "Head of Distribution, Lufthansa",
        slide1ImageAlt: "Lufthansa airport terminal",
        slide2Quote: "Working with DRCT helps us extend the reach of our NDC content to a wider community of travel sellers — without compromising on the experience our customers expect from Emirates.",
        slide2Name: "John Smith",
        slide2Role: "VP Distribution Strategy, Emirates",
        slide2ImageAlt: "Emirates pilots at airport",
        prevLabel: "Previous testimonial",
        nextLabel: "Next testimonial"
      },
      cta: {
        title: "Ready to grow your distribution?",
        description: "Partner as an airline or get access as a travel seller.",
        ctaLabel: "Book a Demo"
      },
      faq: {
        heading: "FAQ",
        description: "If you didn't find an answer to your question, please ask our support.",
        q1: "Which airlines already work with DRCT?",
        a1: "Aegean Airlines, airBaltic, American Airlines, British Airways, Brussels Airlines, Emirates, flydubai, Iberia, LOT, Lufthansa, SWISS, TAP, United Airlines and more than 40 other airlines.",
        demoLabel: "Book a Demo",
        demoAfter: "to get an updated list of integrations.",
        q2: "Is DRCT a ticketing agency?",
        a2: "No, DRCT is a technology provider and airline aggregator. We do not sell air tickets but provide agencies and other ticket sellers with the tech solution for ticketing.",
        q3: "Will I lose my incentive agreement with the airline?",
        a3: "No, all sales via DRCT will be done under your own airline agreements. If it includes incentives, you keep it.",
        q4: "What is NDC?",
        a4: "New Distribution Capabilities (NDC) is an XML-based data transmission standard. NDC enables data transmission directly from air carriers to agents bypassing outdated intermediates such as GDS. It provides access to complete airline content including exclusive fares, ancillaries, and personalised offers.",
        q5: "How to get credentials from an airline?",
        a5: "DRCT's team assists with the application process for airline NDC credentials. Contact us and we will help you get started with all the major airlines in our network.",
        q6: "How to start working?",
        a6: "Installation takes only 10 minutes. Request a demo and our team will guide you through the setup process and 30-day free trial.",
        q7: "Which IATA office is used for ticketing?",
        a7: "Ticketing is done via your own IATA office number. DRCT does not issue tickets — your agency does, using your own credentials and BSP settlement.",
        q8: "Can I trust DRCT?",
        a8: "DRCT is certified by IATA as an Airline Retailing Maturity (ARM) System Provider. We work with over 50 airlines and hundreds of agencies globally.",
        q9: "How to make a refund or exchange?",
        a9: "Refunds and exchanges can be processed directly within the DRCT interface or through your GDS workflow, depending on the airline's NDC capabilities.",
        q10: "What should I do if my airline's NDC lacks functionality?",
        a10: "Our support team provides 24/7 assistance and can escalate directly to the airline's NDC team. We also proactively monitor NDC quality and flag issues before they affect your workflow.",
        q11: "Is it possible to get an ADM using DRCT?",
        a11: "DRCT specifically protects against ADMs. Our workflows are designed to comply with airline requirements and avoid debit memos. We own the migration risk so you don't have to.",
        q12: "How does DRCT search for cheaper booking classes?",
        a12: "DRCT automatically checks every booking for lower NDC fare classes post-purchase. If a better price is found before ticketing, you receive a notification with the option to reprice.",
        q13: "Are the queues available in DRCT?",
        a13: "Yes, DRCT integrates with your GDS queues. You can monitor NDC bookings alongside your regular GDS queue workflow without switching interfaces."
      }
    },
    showAllFunctionality: "VIEW MORE",
    hideAllFunctionality: "HIDE",
    certifiedTitle: "Working with",
    certifiedDescription: "Over 40 leading airlines that have already chosen DRCT as a partner.",
    live: "+30 airlines \nin LIVE",
    impl: "We are currently \nimplementing +10 airlines",
    iataTitle: "ARM System Provider certified by IATA",
    iataDescription: "More information at",
    iataLink: "IATA ARM index registry",
    cookiePrivacy: "Privacy policy",
    cookieText: "By continuing to use this website, you consent to the use of cookies in accordance with our",
    airline_advantage_1: "Integration within 2-4 weeks",
    airline_advantage_2: "Pay as you go",
    airline_advantage_3: "Up to 86% efficient then your OBT",
    airlines: {
      pageTitle: "DRCT for airlines",
      title: "Decrease costs on distribution and the IT infrastructure. Focus on what matters such as fleet operations and passenger experience.",
      description: "DRCT is a tech provider building a new era Uber-like distribution platform to unite carriers and passengers in a solid eco-system delivering a unique shopping experience.",
      presentationPlaceholder: "Enter your e-mail",
      getPresentation: "Request demo",
      contactSoon: "We'll contact you during the day",
      whatWeDo: "What we do",
      whatWeDo1: "Cutting costs on client acquisition on metasearch and search engines",
      whatWeDo2: "Helping airlines to deliver their product value to GDS and metasearch",
      whatWeDo3: "Cutting costs on distribution up to 80% via agent-network",
      whatWeDo4: "Delivering airlines’ personalized offers either in metasearch and GDS",
      whatWeDo5: "Increasing revenue by boosting ancillary sales",
    },
    privacy: {
      pageTitle: "Privacy policy"
    },
    websiteTerms: {
      pageTitle: "Website terms of use"
    },
    extensionTerms: {
      pageTitle: "Extension terms of use"
    },
    communicationPolicy: {
      pageTitle: "Communication policy"
    },
    footerPrivacies: "Policy",
    followUs: "Follow us",
    ourProducts: "Products"
  },
  fr: {
    pageTitle: "Direct est un agrégateur NDC",
    pageDescription: "Vendez les billets aux prix des sites de compagnies aériennes directement depuis le GDS. Réservez, vérifiez les files d'attente et faites des changements. Sans avoir besoin d'apprendre à utiliser de nouvelles interfaces. Aucun frais GDS.",
    forAgencies: "Pour les agences",
    forNonIataAgencies: "Pour les agences non-IATA",
    forOta: "Pour les OTA",
    forAirlines: "Pour les compagnies aériennes",
    forDevelopers: "Pour les développeurs",
    signIn: "Se connecter",
    try: "Essayer gratuitement",
    solutionsMenu: {
      label: "Solutions",
      heading: "Solutions",
      description: "Découvrez comment DRCT aide les compagnies aériennes, les agences et les partenaires de distribution à proposer, distribuer et monétiser des offres aériennes.",
      airlines: {
        title: "Pour les compagnies aériennes",
        description: "Distribuez vos offres et augmentez les revenus des services additionnels sur tous les canaux."
      },
      iataAgencies: {
        title: "Pour les agences IATA",
        description: "Accédez aux offres aériennes et aux services additionnels dans vos workflows existants."
      },
      nonIataAgencies: {
        title: "Pour les agences non-IATA",
        description: "Élargissez l’accès aux offres aériennes sans intégrations directes avec les compagnies aériennes."
      },
      ota: {
        title: "Pour les OTA",
        description: "Proposez des offres aériennes personnalisées à grande échelle."
      }
    },
    mainMessage: "SOYEZ PRO AVEC DRCT",
    mainDescription: "Prix uniques, accessibles uniquement sur les sites des transporteurs, maintenat dans votre GDS. Réservez, vérifiez les files d'attente, faites des changements. Sans avoir besoin d'apprendre à utiliser de nouvelles interfaces. Aucun frais GDS.",
    onePlaceTitle: "Toutes les possibilités sont là",
    onePlaceDescription: "DRCT a tout ce qu'il faut pour travailler avec les réservations.",
    onePlaceOption1: "Tout en restant sur la page du GDS, bénificiez de prix sans frais GDS. Les compagnies aériennes partenaires — Lufthansa, Austrian Airlines, Brussels Airlines, Swiss, Air France, KLM, Ukraine International Airlines, SkyUp, British Airways, Iberia. Bientôt — Air Malta, Vueling.",
    onePlaceOption2: "Accès complet à la réservation — réservez, entrez des données supplémentaires, émettez, voidez, annulez sans sortir du GDS.",
    onePlaceOption4: "Faîtes l'echange, le retour et la deuxième émission par vous-même ou à l'aide du serivce de support 24h/7. La vitesse moyenne de réponse — 30 secondes. 98% de partenaires ont évalué le service de support comme «excellent».",
    onePlaceTitle1: "Réservez moins cher",
    onePlaceTitle2: "Gérez",
    onePlaceTitle3: "Contrôlez",
    onePlaceTitle4: "Changez",
    advantage_1: "Installation en 10 minutes",
    advantage_2: "Période gratuite de 30 jours",
    advantage_3: "Support 24h/7",
    benefitTitle: "Travaillez depuis la même page",
    benefitDescription: "Continuez à travailler dans le GDS de façon habituelle.",
    showAllFunctionality: "Afficher plus",
    hideAllFunctionality: "Cacher",
    benefitTitle1: "Payez via BSP",
    benefitTitle2: "Ajoutez des collaborateurs",
    benefitTitle3: "Contrôlez les données personnelles",
    benefitTitle4: "Soyez au courant",
    benefitTitle5: "Comptabilisez",
    benefitTitle6: "Gagnez plus",
    benefitDescription1: "Utilisez vos propres contrats avec les transporteurs — les mêmes d'après lesquels vous travaillez maintenant. Rien ne change. Le paiement s'effectue toujours via BSP.",
    benefitDescription2: "Contrôlez les balances, ouvrez et fermez les accès à DRCT, élargissez le réseau de partenaires par vous-même. C'est simple et sans bureaucratie.",
    benefitDescription3: "Réglez les rôles et la visibilité des réservations comme vous l'entendez.",
    benefitDescription4: "Recevez des notifications de changements pour être au courant.",
    benefitDescription5: "Déchargez les ventes du DRCT dans votre back-office et middle-оffice. Simple, rapide, gratuit.",
    benefitDescription6: "Lancer la recherche de classes moins chères, et DRCT vérifiera chaque réservation pour les classes inférieures. Si un tarif inférieur apparaît, DRCT vous notifiera.",
    demoTitle: "Essayez par vous-même",
    demoDescription: "Entrez la commande de tarification de GDS pour obtenir le prix comme sur le site du transporteur.",
    demoHelpDescription: "Entrez la commande de tarification du GDS",
    demoChangePnr: "Essayer un autre itinéraire",
    demoDrctHeader: "Réservez pour fixer le prix",
    desireToBook: "Essayez votre version gratuite pour réserver",
    book: "Réserver",
    savingsTitle: "Gagnez plus dès demain",
    savingsDescription: "Période gratuite 30 jours. Indiquez votre volume de ventes de billets des compagnies disponibles à DRCT, et recevez le prix. Le calcul du tarif est fait pour les compagnies LH, OS, LX, SN, AF, KL, BA, IB, PS, U5, KM, OA incluant le prix NDC et excluant les frais de GDS.",
    savingsEconomy_1: "Le gain avec DRCT sur",
    savingsEconomy_2: "billets",
    questionTitle: "Nous répondrons à vos questions",
    questionDescription: "Si vous n'avez pas trouvé une réponse à votre question, écrivez-nous dans le chat. Nous vous aiderons avec plaisir 💙",
    askQuestion: "Poser une question",
    questionTitle1: "Avec quelles compagnies fonctionne DRCT?",
    questionTitle2: "Est-ce que DRCT est une agence de vente de billets?",
    questionTitle3: "Est-ce que je vais perdre mon incentive?",
    questionTitle4: "Qu'est-ce que NDC?",
    questionTitle5: "Comment obtenir un accès direct de la part de la compagnie?",
    questionTitle6: "Comment commencer à travailler?",
    questionTitle7: "A travers quel bureau IATA sont effectuées les réservations et les émissions?",
    questionTitle8: "Est-ce sécurisé?",
    questionTitle9: "Comment faire le retour ou l'échange de billet?",
    questionTitle10: "Que faire s'il faut échanger le billet en urgence?",
    questionTitle11: "Peut-on obtenir un ADM, en travaillant dans DRCT?",
    questionTitle12: "Comment fonctionne la recherche de classes moins chères?",
    questionTitle13: "Est-ce qu'il y a des files d'attente dans DRCT?",
    questionAnswer1: "Les compagnies aériennes accessibles sont Lufthansa, Austrian Airlines, Brussels Airlines, Swiss, Air France, KLM, Ukraine International Airlines, SkyUp, British Airways, Iberia, Air Malta, Olympic Air. Bientôt — Aegean Airlines, American Airlines, Air Arabia, Level, Singapore Airlines, Vueling.",
    questionAnswer2: "Non, DRCT est un fournisseur technologique. Comme la GDS, mais en mieux. Nous ne vendons pas de billets, nous fournissons des services techniques aux agents et aux compagnies pour la vente de billets.",
    questionAnswer3: "Non, toutes les ventes vont inclure votre contrat existant avec le transporteur. Le paiement s'effectue habituellement via le BSP où par la carte de crédit.",
    questionAnswer4: "NDC est un protocole qui aide les compagnies à transmettre l'information des transporteurs au passager sans intermédiaires comme le GDS. NDC fournit l'accès à tous les tarifs de transporteurs et, dans l'avenir, aux contenus plus qualitatifs. <a target='_blank' href='https://www.iata.org/en/programs/airline-distribution/ndc/#tab-5'>Plus en détails sur le site IATA.</a>",
    questionAnswer5: "Demandez l'accès auprès d'un représentant des transporteurs. Vous ne savez pas comment? Ecrivez dans le chat et nous vous aiderons. Si vous avez des accès, utilisez-les pour commencer à travailler à DRCT.",
    questionAnswer6: "Vous pouvez commencer dès maintenant. Période d'essai de 30 jours.",
    questionAnswer7: "La réservation et l'émission à DRCT s'effectue via votre IATA.",
    questionAnswer8: "DRCT a passé la certification d'IATA pour obtenir le statut d'agrégateur de niveau 4. La certification confirme que DRCT correspond à toutes les exigences techniques d'IATA. <a target='_blank' href='https://www.iata.org/en/programs/airline-distribution/ndc/registry/drct/290/'>Veuillez trouver plus d'informations sur le site d'IATA dans la section NDC Registry.</a>\n\nDRCT est certifié par Lufthansa, Austrian Airlines, Brussels Airlines, SWISS, Air France, KLM, British Airways, Iberia, Air Malta, Olympic Air. <a target='_blank' href='https://www.iata.org/en/programs/airline-distribution/ndc/matchmaker/players/drct-ltd/aB51r000000XZYFCA4/'>Information sur les intégrations sur le site d'IATA.</a>",
    questionAnswer9: "C'est notre service de support qui effectuera le retour ou l'échange. Ecrivez le PNR de la réservation dans le chat. Nous annoncerons le prix et après votre approbation, nous effecturons les changements nécessaires.",
    questionAnswer10: "Le support est joignable 24h/7. D'après les données d'Intercom.com, la vitesse moyenne d'une réponse — 30 secondes, et 98% de partenaires ont évalué notre service de support comme «excellent».",
    questionAnswer11: "En travaillant dans DRCT, vous ne recevrez pas d'ADM pour une commission incorrecte, l'absence de données de contact dans une réservation ou bien une faute — nous en prenons la responsabilité.",
    questionAnswer12: "Nous vérifions automatiquement à DRCT la présence de classes moins chères. Quand nous les trouvons, nous vous en informerons et proposerons le prix le moins cher de la réservation.",
    questionAnswer13: "L'information au sujet des annulations, retards des vols, et changements d'heure limite d'emission sont communiqués viq des notifications dans DRCT. Contrairement au GDS, il n'est pas nécessaire de vérifier la file d'attente dans DRCT. La notification concernant le changement sera affichée sur le site.",
    footerPrivacy: "Politique de confidentialité",
    vueling: "En juillet 2020",
    plus: "+12 compagnies aériennes \navant la fin de 2020",
    certifiedTitle: "Ils nous font confience",
    certifiedDescription: "Plus de 20 compagnies aériennes leaders ont déjà choisi DRCT comme partenaire. Rejoignez la communauté.",
    iataTitle: "Agrégateur certifié de niveau 4",
    iataDescription: "Veuillez trouver plus d'informations sur le site d'IATA dans la section",
    iataLink: "NDC Registry",
    cookiePrivacy: "Politique de confidentialité",
    cookieText: "En poursuivant votre navigation sur ce site, vous acceptez l’utilisation de cookies conformément à notre",
    airline_advantage_1: "Integration de 2 à 4 semaines",
    airline_advantage_2: "Payez au fur et à mesure",
    airline_advantage_3: "Plus efficace que votre OBT, jusqu'à 86%",
    airlines: {
      pageTitle: "Direct pour les compagnies aériennes",
      title: "Rendrons les compagnies aériennes plus proches des passagers",
      description: "DRCT est un fournisseur de technologie qui construit une nouvelle plateforme de distribution de type uber pour réunir les transporteurs et les passagers dans un écosystème solide offrant une expérience d'achats unique.",
      presentationPlaceholder: "Entrer votre adresse mail",
      getPresentation: "En savoir plus",
      contactSoon: "Nous vous contacterons dans la journée",
      whatWeDo: "Ce que nous faisons",
      whatWeDo1: "Nous réduisons les coûts d'acquisition de clients sur les méta-recherches et les moteurs de recherche",
      whatWeDo2: "Nous aidons les compagnies aériennes à fournir leur valeurs de produit dans le GDS et la méta-recherche",
      whatWeDo3: "Nous réduisons les coûts de distribution jusqu'à 80% via le réseau d'agents",
      whatWeDo4: "Nous livrons les offres personnalisées des compagnies aériennes aux méta-recherches et au GDS",
      whatWeDo5: "Nous augmentons vos revenus en boostant les ventes accessoires",
    },
    footerPrivacies: "Policy",
    followUs: "Nous suivre",
    ourProducts: "Produits"
  },
  es: {
    pageTitle: "Direct — agregador NDC",
    pageDescription: "Venda billetes a precios de sitios web de aerolíneas directamente en GDS. Haga reservas, gestione colas, introduzca modificaciones sin necesidad de aprender interfaces nuevas. Sin tasas GDS.",
    forAgencies: "Para agencias",
    forNonIataAgencies: "Para agencias no IATA",
    forOta: "Para OTA",
    forAirlines: "Para aerolíneas",
    forDevelopers: "Para desarrolladores",
    signIn: "Ingresar",
    try: "Probar",
    solutionsMenu: {
      label: "Soluciones",
      heading: "Soluciones",
      description: "Descubre cómo DRCT ayuda a aerolíneas, agencias y socios de distribución a ofrecer, distribuir y monetizar ofertas aéreas.",
      airlines: {
        title: "Para aerolíneas",
        description: "Distribuye ofertas y aumenta los ingresos auxiliares en todos los canales."
      },
      iataAgencies: {
        title: "Para agencias IATA",
        description: "Accede al inventario aéreo y a servicios auxiliares en tus flujos de trabajo actuales."
      },
      nonIataAgencies: {
        title: "Para agencias no IATA",
        description: "Amplía el acceso al inventario aéreo sin integraciones directas con aerolíneas."
      },
      ota: {
        title: "Para OTA",
        description: "Ofrece propuestas aéreas personalizadas a escala."
      }
    },
    mainMessage: "Sé experto con DRCT",
    mainDescription: "Tarifas únicas, disponibles solamente en las páginas de aerolíneas, ahora también en su GDS. Haga reservas, gestione colas, introduzca modificaciones sin necesidad de aprender interfaces nuevas. Sin tasas GDS.",
    onePlaceTitle: "Todas las posibilidades al alcance de la mano",
    onePlaceDescription: "En DRCT hay todo lo necesario para trabajar con reservas.",
    onePlaceOption1: "Todas las tarifas de compañías aéreas sin tasas GDS sin salir de GDS. Aerolíneas — Lufthansa, Austrian Airlines, Brussels Airlines, Swiss, Air France, KLM, Ukraine International Airlines, SkyUp, British Airways, Iberia. Próximamente — Air Malta.",
    onePlaceOption2: "Acceso completo a las reservas — reserve, introduzca datos adicionales, emita, devuelva, anule sin salir de GDS.",
    onePlaceOption3: "Reciba notificaciones sobre retrasos, cancelación de vuelos, modificaciones de límites de tiempo para estar al corriente.",
    onePlaceOption4: "Cambio, devolución, revalidación — por su propia cuenta o con ayuda de soporte de 24 horas. Tiempo promedio de espera de respuesta — 30 segundos. 98% de socios calificaron nuestro servicio de soporte como «excelente».",
    onePlaceTitle1: "Reserve más barato",
    onePlaceTitle2: "Administre",
    onePlaceTitle3: "Controle",
    onePlaceTitle4: "Modifique",
    advantage_1: "Tiempo de instalación — 10 minutos",
    advantage_2: "Período gratuito — 30 días",
    advantage_3: "Soporte 24 horas",
    benefitTitle: "Trabaje en un solo sitio",
    benefitDescription: "Siga trabajando en GDS de manera habitual.",
    showAllFunctionality: "Más detalles",
    hideAllFunctionality: "Ocultar",
    benefitTitle1: "Pague a través de BSP",
    benefitTitle2: "Agregue empleados",
    benefitTitle3: "Controle datos personales",
    benefitTitle4: "Este al corriente",
    benefitTitle5: "Mantenga registro",
    benefitTitle6: "Empiece ganar más",
    benefitDescription1: "Utilice sus contratos con aerolíneas — los mismos que está usando en este momento. Nada se va a cambiar. Pagos a través de BSP — como siempre.",
    benefitDescription2: "Controle saldo, abra y cierre accesos a DRCT, amplie la red de colaboradores por su propia cuenta. Sencillo y sin burocracia.",
    benefitDescription3: "Configura acceso y visibilidad de las reservas según su propio criterio.",
    benefitDescription4: "Reciba notificaciones sobre cambios para estar al corriente.",
    benefitDescription5: "Descargue los informes de ventas desde DRCT a sus departementos de back y middle office. Sencillo, rápido, gratis.",
    benefitDescription6: "Active búsqueda de clases más baratas y DRCT revisará cada reserva buscando las clases más bajas. En el caso de aparición una tarifa más baja DRCT le avisará.",
    demoTitle: "Pruebelo ",
    demoDescription: "Cotiza con transacción desde GDS para obtener el precio del sitio web de compañía aérea.",
    demoHelpDescription: "Cotiza con transacción  desde GDS",
    demoChangePnr: "Intentar otra ruta",
    demoDrctHeader: "Haga reserva para almacenar tarifa",
    commandsTitle: "Введите команду просчёта GDS",
    desireToBook: "Pruebe la versión gratuita para hacer reserva",
    book: "Hacer reserva",
    savingsTitle: "Empiece ganar más ahora",
    savingsDescription: "Período gratuito 30 días. Indique el volumen de ventas de su agencia con los compañías aéreas disponibles en DRCT, y le calcularemos su prosupuesto.\nCálculo basado en aerolíneas LH, OS, LX, SN, AF, KL, BA, IB, PS, U5, KM, OA tomando en cuenta tarifas NDC y sin tasas GDS.",
    savingsEconomy_1: "Gane con DRCT en",
    savingsEconomy_2: "billetes",
    questionTitle: "Responderemos sus preguntas",
    questionDescription: "¿No ha podido encontrar respuesta a su pregunta? Escríbanos al chat y estaremos encantados de ayudarle💙",
    askQuestion: "Hacer pregunta",
    questionTitle1: "¿Cuáles son las compañías aéreas con las que  trabaja DRCT?",
    questionTitle2: "¿DRCT es una agencia de venta de billetes?",
    questionTitle3: "¿Perderé sus contratos de incentive?",
    questionTitle4: "¿Qué es NDC?",
    questionTitle5: "¿Cómo obtener el acceso directo de una aerolínea?",
    questionTitle6: "¿Cómo empezar a trabajar?",
    questionTitle7: "¿A través de qué oficina de IATA se realiza la reserva y emisión?",
    questionTitle8: "¿Es seguro?",
    questionTitle9: "¿Cómo realizar devolución o cambio de billete?",
    questionTitle10: "¿Qué hacer si nesesita cambiar  urgentemente el billete?",
    questionTitle11: "¿Es posible recibir ADM trabajando en DRCT?",
    questionTitle12: "¿Cómo funciona búsqueda de clases más baratas?",
    questionTitle13: "¿En DRCT existen colas?",
    questionAnswer1: "Aerolíneas disponibles — Lufthansa, Austrian Airlines, Brussels Airlines, Swiss, Air France, KLM, Ukraine International Airlines, SkyUp, British Airways, Iberia, Air Malta, Olympic Air. Próximamente — Aegean Airlines, American Airlines, Air Arabia, Level, Singapore Airlines, Vueling.",
    questionAnswer2: "No, DRCT es un proveedor tecnológico. Igual que GDS, pero mejor. no vendemos billetes, proveemos soluciones tecnológicas de venta de billetes  para agentes y  aerolíneas .",
    questionAnswer3: "No, todas las ventas incluyen sus contratos vigentes con diferentes compañías aéreas. Pago se realiza de manera habitual — mediante BSP o tarjeta bancaria.",
    questionAnswer4: "NDC es un protocolo que ayuda a las aerolíneas transmitir los datos de aerolínea directamente al pasajero, evitando intermediarios — GDS. NDC da acceso a todas las tarifas de aerolíneas y, en el futuro, al servicio más amplio y de mejor calidad. <a target='_blank' href='https://www.iata.org/en/programs/airline-distribution/ndc/#tab-5'>Más detalles en la página oficial de IATA.</a>",
    questionAnswer5: "Para solicitar el acceso diríjase a un representante de aerolínea. ¿No sabe cómo hacerlo? Escríbanos al chat y le ayudaremos. Si ya tiene accesos, puede utilizarlos para trabajar en DRCT.",
    questionAnswer6: "Puede empezar ahora mismo. Período gratuito 30 días.",
    questionAnswer7: "Reserva y emisión en DRCT se realiza a través de su oficina de IATA.",
    questionAnswer8: "DRCT ha pasado exitosamente la certificación IATA para convertirse en un agregador NDC de Nivel 4.  La certificación confirma que DRCT cumple con todos los requisitos técnicos de IATA. <a target='_blank' href='https://www.iata.org/en/programs/airline-distribution/ndc/registry/drct/290/'>Puede leer más sobre la información en el sitio web de IATA en la sección NDC Registry.</a>\n\nDRCT está certificado por Lufthansa, Austrian Airlines, Brussels Airlines, SWISS, Air France, KLM, British Airways, Iberia, Air Malta, Olympic Air. <a target='_blank' href='https://www.iata.org/en/programs/airline-distribution/ndc/matchmaker/players/drct-ltd/aB51r000000XZYFCA4/'>Información sobre integraciones en el sitio web de IATA.</a>",
    questionAnswer9: "Devolución o cambio realizará Departamento de soporte. Indique el número localizador de reserva en el chat — nosotros le calcularemos el coste y después de su aprobación realizaremos los cambios necesarios.",
    questionAnswer10: "Departamento de soporte trabaja 24 horas. Según los datos de intercom.com, el tiempo promedio de espera de respuesta — 30 segundos y 98% de socios evaluaron nuestro servicio de soporte como «excelente».",
    questionAnswer11: "Trabajando en DRCT  no recibirá ADM por una comisión incorrecta, ausencia de datos de contacto en la reserva o error durante el intercambio con nuestro soporte  —  asumimos toda la responsabilidad.",
    questionAnswer12: "Automáticamente revisamos todas las reservas en DRCT buscando las clases más económicas. En el caso de encontrarlas nosotros le avisaremos y reduciremos el precio de reserva.",
    questionAnswer13: "Información sobre cancelaciones, retrasos de vuelos y cambios de tiempo limite en las reservas se refleja en las notificaciones de DRCT. A diferencia de GDS, en DRCT no es necesario gestionar las colas. Notificación sobre modificaciones aparecerá en la página.",
    footerPrivacy: "Política de privacidad",
    vueling: "En Julio 2020",
    plus: "+12 aerolíneas\ n hasta el final de 2020",
    certifiedTitle: "Confían en nosotros",
    certifiedDescription: "Más de 20 aerolíneas líderes eligieron a DRCT como socio.  Únete con nosotros.",
    iataTitle: "Agregador NDC certificado de Nivel 4",
    iataDescription: "Puede saber más sobre la información en el sitio web de IATA en la sección",
    iataLink: "NDC Registry",
    cookiePrivacy: "Con la política de privacidad",
    cookieText: "Al continuar utilizando este sitio web, usted acepta el uso de cookie de acuerdo con nuestra",
    airline_advantage_1: "Integración en 2-4 semanas",
    airline_advantage_2: "Pago de acuerdo con el uso",
    airline_advantage_3: "Hasta 86% más eficiente que OBT",
    airlines: {
      pageTitle: "Direct – para aerolíneas",
      title: "Hacemos aerolíneas más cerca con los pasajeros",
      description: "Un proveedor tecnológico que crea una plataforma de distribución similar a Uber que unirá a los transportistas, agentes y pasajeros en un solo ecosistema.",
      presentationPlaceholder: "Ingresa su correo electrónico",
      getPresentation: "Más información",
      contactSoon: "Estaremos en contacto contigo durante el día",
      whatWeDo: "Qué hacemos nosotros?",
      whatWeDo1: "Reducimos los costos de llamar las atención de los clientes en metabuscadores y en los sistemas de buscadores",
      whatWeDo2: "Ayudamos a las aerolíneas a proveer el valor a GDS y metabuscadores",
      whatWeDo3: "Reducimos los costos de distribución a través de la red de los agentes hasta 80%",
      whatWeDo4: "Llevamos ofertas personalizas de aerolíneas a metabuscadores y GDS",
      whatWeDo5: "Incrementamos los ingresos a través de ventas de servicios adicionales",
    },
    privacy: {
      pageTitle: "Política de privacidad"
    },
    footerPrivacy: "Privacidad",
    footerPrivacies: "Políticos",
    followUs: "Síguenos",
    ourProducts: "Productos"
  },
  ua: {
    landingPromotion: {
      desktop: "DRCT на World Aviation Festival у Лісабоні 13–15 жовтня. Завітайте до нас на стенд 1-102C.",
      mobile: "До зустрічі на WAF Lisbon 13–15 жовт.",
      ctaLabel: "Детальніше",
      dismissLabel: "Закрити оголошення про World Aviation Festival"
    },
    landingNavigation: {
      toggleLabel: "Відкрити або закрити меню",
      mainLabel: "Основна навігація"
    },
    apiMessage: "Почніть продавати квитки з DRCT API",
    apiDescription: "Побудуйте свій туристичний бізнес за допомогою швидко інтегрованого DRCT API. Оформлюйте квитки за унікальними тарифами без комісії GDS. Ознайомтеся з документацією та надішліть перший запит, щоб почати роботу за 5 хвилин.",
    advantage_api_1: "Інтеграція за 5 днів",
    advantage_api_2: "Без початкової плати",
    advantage_api_3: "Підтримка 24/7",
    apiOnePlaceTitle1: "Пошук",
    apiOnePlaceOption1: "Усі необхідні методи пошуку рейсів і ціноутворення доступні для отримання актуальної інформації. ",
    apiOnePlaceTitle2: "Бронювання та виписка",
    apiOnePlaceOption2: "Після створення бронювання ’виться тайм-ліміт. Бронювання має бути оформлене в будь-який час раніше зазначеного тайм-ліміту.",
    apiOnePlaceTitle3: "Післяпродажне обслуговування",
    apiOnePlaceOption3: "Войд квитків та скасування бронювання. Обмін та повернення квитків можливі через нашу підтримку.",
    apiOnePlaceTitle4: "Додаткові послуги",
    apiOnePlaceOption4: "Замовлення будь-яких додаткових послуг від харчування та місць на борту до перевезення домашніх тварин. Скоро буде в доступно.",
    apiOnePlaceTitle: "Усі інструменти в одному додатку",
    apiOnePlaceDescription: "Ми зібрали все необхідне для оформлення квитка за найкращою ціною та супроводом клієнта від покупки до посадки.",
    apiBenefitsTitle: "Зручний для розробників 💙",
    apiBenefitsDescription: "DRCT API створено з любо’ до розробників. \n Вам не потрібно розбиратися зі складними API авіакомпаній — ми вже зробили це за вас.",
    apiBenefitTitle1: "Комплексна документація",
    apiBenefitDescription1: "Ми зробили все можливе, щоб документація була зрозумілою та простою. Швидко почніть роботу з документацією, <a target='_blank' href='https://www.postman.com/drct-api/workspace/drct-api/overview'>Postman workspace</a>, і стабільним тестовим середовищем.",
    apiBenefitTitle2: "Простий у використанні інструмент бронювання",
    apiBenefitDescription2: "Допомагає переконатися, що запити надсилаються правильно, щоб рейси та створені бронювання відображалися належним чином.",
    apiBenefitTitle3: "Підтримка",
    apiBenefitDescription3: "Для нас дуже важливо, щоб наша документація API була точною та зрозумілою. Якщо у вас виникли запитання або хочете поділитися відгуком, просто зв’яжіться з нами в чаті.",
    pageTitle: "DRCT для агентств",
    pageDescription: "Продавайте рейси та додаткові послуги напряму з авіакомпаніями, не виходячи з GDS. Збільшуйте свої націнки завдяки агенто-орієнтованому застосунку та нульовій комісії за продаж квитків.",
    forAgencies: "Для агентств",
    forNonIataAgencies: "Для агентств без акредитації IATA",
    forOta: "Для OTA",
    forAirlines: "Для авіакомпаній",
    forDevelopers: "Для розробників",
    signIn: "Увійти",
    try: "Запланувати демо",
    solutionsMenu: {
      label: "Рішення",
      heading: "Рішення",
      description: "Знайдіть рішення DRCT для дистрибуції, продажу або інтеграції пропозицій авіакомпаній.",
      airlines: {
        title: "Для авіакомпаній",
        description: "Тарифи, бандли й додаткові послуги без змін у GDS, NDC і прямих каналах — без втрати охоплення агентів."
      },
      iataAgencies: {
        title: "Для IATA-агентств",
        description: "Повний авіаконтент у звичній роботі — від бронювання й обслуговування до звітності BSP. Підтримка 24/7."
      },
      nonIataAgencies: {
        title: "Для агентств без акредитації IATA",
        description: "Виписка й обслуговування з першого дня — без IATA, договорів з авіакомпаніями та знань GDS."
      },
      ota: {
        title: "Для OTA",
        description: "Підключіть NDC, лоукости й чартери через один API з єдиним форматом даних і лімітами L2B для потреб OTA."
      }
    },
    productsMenu: {
      label: "Продукти",
      heading: "Продукти",
      description: "Оберіть продукт DRCT для бронювання, інтеграції або обслуговування квитків.",
      workspace: {
        title: "Workspace",
        description: "Пошук, бронювання й обслуговування всього авіаконтенту — у робочому просторі вашого агентства."
      },
      api: {
        title: "API",
        description: "Одне API для всіх джерел: єдиний формат, вигідні ціни й високі ліміти L2B, без окремої логіки."
      },
      extension: {
        title: "Extension",
        description: "Повний контент авіакомпаній із додатковими послугами у звичних інструментах — без зміни процесів."
      }
    },
    exploreDocs: "До документації",
    airlinesMessage: "Наближаємо авіакомпанії до пасажирів",
    airlinesDescription: "DRCT це постачальник технологій, який створює платформу дистрибуції нової ери, подібну до Uber, щоб об’єднати перевізників і пасажирів у надійну екосистему, що забезпечує унікальний досвід покупок.",
    airlinesAdvantage1: "Запуск протягом 2-4 тижнів",
    airlinesAdvantage2: "Недорога дистрибуція",
    airlinesAdvantage3: "Підтримка 24/7",
    airlinesCostsTitle: "Зниження витрат 📉",
    airlinesCostsDescription: "Мета DRCT полягає в тому, щоб зробити дистрибуцію авіакомпаній більш ефективною — простий, персоналізований і недорогий. Ми зосереджуємося на технологіях, щоб авіакомпанії могли зосередитися на продукті.",
    airlinesCostsBenefit1Title: "Про вихід на нові ринки та клієнтів",
    airlinesCostsBenefit1Desc: "Розвиток бізнесу на зовнішніх ринках завжди є викликом для авіакомпаній. Особливо на ринках, де частка ринку авіакомпанії низька. Збір платежів і укладання контрактів дорогі. \n \nDRCT інтегровано з GDS, системами платежів і представлено глобальними GSA та всіма основними ринками. Використовуючи існуючі з’єднання, ми робимо можливим продавати квитки через GDS на будь-якому ринку та приймати платежі через BSP або кредитну картку без суєти чи комісій GDS.",
    airlinesCostsBenefit2Title: "Про підтримку власного OBT та API",
    airlinesCostsBenefit2Desc: "Розробка та підтримка власного OBT коштує дорого та неефективна. Практично неможливо змусити продавців використовувати OBT різних авіакомпаній для пошуку рейсів. Надання та підтримка власного API або OBT також є проблемою — впровадження слотів, сертифікація, підтримка та укладання контрактів. Усе це означає, що авіакомпанія витрачає ресурси на технічний персонал замість того, щоб розвивати свій бізнес. \n \nDRCT доставляє контент продавцю через API або OBT. Інтегрована з сотнями продавців, наша команда чітко розуміє вимоги будь-якого продавця — TMC, OTA, Традиційні Агентства. DRCT вже має інтеграцію з системами середнього та бек-офісів, тому впровадження рішень DRCT є найпростішим способом отримати контент від усіх необхідних авіакомпаній без необхідності впроваджувати OBT або API кожної авіакомпанії.",
    airlinesRevenuesTitle: "Збільшення доходів 📈",
    airlinesRevenuesDescription: "Авіабізнес малорентабельний. Використовуючи сучасні технології та доступ до ринків, DRCT надає можливості для зростання прибутку та маржі.",
    airlinesRevenuesBenefit1Title: "За рахунок розширення мережі",
    airlinesRevenuesBenefit1Desc: "Традиційна бізнес-модель авіакомпанії з розбудови власної мережі та дистрибуції через GDS — уже не затребувана. Переважає модель «точка-точка» з прямими каналами розподілу. Але є у неї і недоліки. Відсутність транзитних пасажирів і обмежена дистрибуція робить цю модель малорозширюваною. \n \nDRCT є агрегатором для багатьох авіакомпаній, ми також підключені до більшості CRS та всіх GDS. Це дає змогу швидко й легко налагоджувати партнерські відносини без змін у бізнес-моделях і структурах ціноутворення. Ми також ефективно доставляємо цей контент продавцям по всьому світу.",
    airlinesRevenuesBenefit2Title: "Використання глибокого аналізу даних і персоналізації, щоб продавати більше",
    airlinesRevenuesBenefit2Desc: "Під час дистрибуції авіакомпанії можуть отримати частину дуже обмеженої інформації про запити на рейси. У більшості випадків це просто анонімний запит ціни та бронювання. Відсутність інформації про те, хто запитує, і фактичні пропозиції конкурентів унеможливлюють створення пропозицій на основі даних. \n \nDRCT отримує масу інформації безпосередньо від продавця в момент запиту. У більшості випадків ми знаємо, хто шукає рейс, попередню історію покупок і пропозиції від усіх авіакомпаній, які пропонуються пасажиру. Це дає нам унікальну перевагу створювати персоналізовані пропозиції, які ідеально відповідатимуть очікуванням пасажирів.",
    footerPrivacy: "Політика конфіденційності",
    footerWebsiteTerms: "Умови користування сайтом",
    footerExtensionTerms: "Умови користування Extension",
    home: {
      pageTitle: "DRCT — платформа агрегації та дистрибуції авіаконтенту",
      pageDescription: "DRCT об’єднує авіапропозиції з GDS, NDC, прямих і лоукост-каналів в єдиному шарі дистрибуції для продавців авіаквитків.",
      hero: {
        title: "Ми адаптуємо й активуємо пропозиції авіакомпаній для різних аудиторій туристичного ринку",
      subtitle: "DRCT — єдиний оркестраційний шар для вашої дистрибуції: від IATA-агентств до OTA та суперзастосунків",
        description: "Авіакомпанії повністю контролюють представлення своїх пропозицій на ринку. Продавці туристичних послуг отримують доступ до пропозицій із прямих каналів авіакомпаній через NDC та індивідуальні схеми дистрибуції — без окремої інтеграції кожного джерела. Агентства водночас зберігають звичні робочі процеси й інтерфейси GDS. Єдина платформа об’єднує обидві сторони й усуває фрагментацію.",
        ctaLabel: "Запланувати демо",
        chipIataAgencies: "IATA-агентства",
        chipOta: "OTA",
        chipNonIataAgencies: "Агентства без акредитації IATA",
        chipTmc: "TMC",
        chipSuperApps: "Суперзастосунки",
        chipTravelTechStartups: "Технологічні стартапи в туризмі"
      },
      gain: {
        heading: "Проблеми, які ми вирішуємо",
        description: "DRCT усуває структурні проблеми для авіакомпаній і продавців туристичних послуг.",
        tabSellers: "Для продавців",
        tabAirlines: "Для авіакомпаній",
        airlineCard1Title: "Повний контроль",
        airlineCard1Desc: "Кожен агент і OTA бачить структуру вашої пропозиції саме такою, як ви її визначили: тарифи, пакети й додаткові послуги узгоджені в усіх каналах.",
        airlineCard2Title: "Вигідніше масштабування",
        airlineCard2Desc: "Пряма дистрибуція й поступовий перехід на NDC знижують вартість бронювання без втрати охоплення ринку чи агентської мережі.",
        airlineCard3Title: "NDC у звичних інструментах",
        airlineCard3Desc: "Контент NDC доступний у знайомих агентам інтерфейсах GDS. Без нових систем і перенавчання — перехід відбувається природно.",
        airlineCard4Title: "Єдиний рівень для обох каналів",
        airlineCard4Desc: "GDS і NDC працюють на єдиному рівні дистрибуції: керування, звітність і розрахунки відбуваються в одному місці, а не у двох паралельних системах.",
        sellerCard1Title: "Увесь контент — одне підключення",
        sellerCard1Desc: "Контент із GDS, NDC та прямих каналів авіакомпаній об’єднано в єдиний нормалізований шар: одна інтеграція й повне охоплення всіх джерел.",
        sellerCard2Title: "Єдиний процес, єдиний інтерфейс",
        sellerCard2Desc: "Шукайте, бронюйте, оформлюйте квитки й обслуговуйте бронювання з будь-якого джерела в одному інтерфейсі — без окремих облікових записів та узгодження форматів.",
        sellerCard3Title: "Доступ до NDC без зайвих бар’єрів",
        sellerCard3Desc: "Отримуйте тарифи NDC та прямі пропозиції авіакомпаній без окремої акредитації в кожного перевізника чи нових контрактів — у звичних робочих процесах.",
        sellerCard4Title: "Єдине післяпродажне обслуговування",
        sellerCard4Desc: "Зміни, обміни, повернення й анулювання квитків обробляються через єдину систему керування замовленнями — за однаковим процесом для всіх підключених авіакомпаній."
      },
      flow: {
        heading: "Як працює екосистема",
        description: "Структурований процес дистрибуції: від пропозицій у вихідному вигляді до готових рішень для продавців — на платформі DRCT.",
        sourceEyebrow: "Пропозиція авіакомпанії",
        sourceHeading: "Початковий формат",
        sourceItem1: "GDS",
        sourceItem2: "NDC",
        sourceItem3: "Індивідуальні схеми дистрибуції",
        coreEyebrow: "Оркестраційний шар",
        coreHeading: "Адаптація. Збагачення. Активація.",
        pipeline1: "Нормалізація — уніфікований формат",
        pipeline2: "Збагачення — пакети, додаткові продажі, контекстні рекомендації",
        pipeline3: "Обслуговування — повний цикл роботи через NDC, індивідуальні API та GDS",
        coreNote: "Єдиний спосіб роботи з пропозиціями незалежно від джерела",
        destEyebrow: "Продавець",
        destHeading: "Готове рішення для продавця",
        destItem1: "Агентство",
        destItem2: "OTA, Суперзастосунок",
        destItem3: "TMC",
        step1Heading: "Повний доступ до контенту",
        step1Desc: "Увесь контент авіакомпаній із різних джерел об’єднано в єдиний дистрибуційний шар.",
        step2Heading: "Збагачення",
        step2Desc: "Пропозиція збагачується додатковими можливостями: віртуальним інтерлайнінгом, брендованими тарифами й додатковими послугами, ціновою та тарифною логікою, інтеграціями з бек- і мід-офісами.",
        step3Heading: "Адаптація до аудиторії",
        step3Desc: "Ми адаптуємо пропозиції до кожного каналу дистрибуції та аудиторії, щоб вони відповідали потребам різних продавців туристичних послуг і були зручними для них.",
        step4Heading: "Навчання та підтримка 24/7",
        step4Desc: "Постійно допомагаємо партнерам: підключаємо, навчаємо та надаємо операційну підтримку в усіх процесах дистрибуції."
      },
      network: {
        liveTitle: "Понад 50 авіакомпаній у мережі",
        liveAlt: "Понад 50 підключених авіакомпаній",
        moreComingTitle: "Незабаром нові авіакомпанії",
        moreComingAlt: "Нові авіакомпанії приєднуються до мережі",
        heading: "Провідні авіакомпанії. Одна інтеграція.",
        description: "Отримуйте прямі нормалізовані пропозиції провідних авіакомпаній через єдину інтеграцію — з повним контентом, з однаковими умовами й без окремих контрактів із кожним перевізником.",
        liveLabel: "Уже в мережі",
        moreComingLabel: "Незабаром ще більше",
        certHeading: "Постачальник системи ARM, сертифікований IATA",
        certDescriptionBefore: "Докладніше в",
        certLinkLabel: "реєстрі IATA ARM"
      },
      metrics: {
        title: "DRCT у цифрах",
        value1: "50",
        suffix1: "+",
        label1: "Підключені авіакомпанії",
        desc1: "Повносервісні та лоукост-перевізники вже працюють у мережі.",
        value2: "4 000",
        suffix2: "+",
        label2: "Продавці туристичних послуг",
        desc2: "Агенти TMC, OTA та API-партнерів у всьому світі.",
        value3: "500",
        suffix3: "+",
        label3: "Агентства-партнери",
        desc3: "TMC, OTA та туристичні агентства в Європі, Великій Британії та США."
      },
      why: {
        heading: "Чому DRCT",
        description: "Переваги єдиної платформи авіадистрибуції — простими словами.",
        item1Title: "GDS і NDC на одній платформі",
        item1Desc: "Гібридна дистрибуція без двох паралельних систем. Контент NDC і GDS об’єднано та стабільно надається кожному продавцю.",
        item2Title: "Без перемикання між системами",
        item2Desc: "Авіакомпанії керують дистрибуцією, а продавці бронюють, вносять зміни й обслуговують замовлення в одному місці. Увесь процес — на платформі DRCT.",
        item3Title: "Більше, ніж традиційний агрегатор авіаконтенту",
        item3Desc: "DRCT збагачує пропозиції: додає додаткові послуги, формує пакети та складає маршрути з рейсів кількох авіакомпаній. У результаті продавець отримує повнішу пропозицію, ніж у вихідному каналі перевізника.",
        item4Title: "Доступ до NDC без зайвих бар’єрів",
        item4Desc: "Продавці отримують тарифи NDC та контент авіакомпаній у звичних інтерфейсах. Без нової акредитації та окремого підключення до NDC кожної авіакомпанії.",
        item5Title: "Плавний перехід без перебудови процесів",
        item5Desc: "Авіакомпанії, які переходять із GDS на NDC, використовують DRCT, щоб робити це поступово: зберігати повне охоплення й одночасно нарощувати обсяг прямих продажів.",
        item6Title: "Охоплюємо всі типи продавців",
        item6Desc: "Агентства IATA, агенти без акредитації IATA, OTA, TMC і суперзастосунки — усі підключаються через єдину платформу дистрибуції.",
        wideTitle: "Операційна підтримка 24/7",
        wideDesc: "Власна команда DRCT опрацьовує проблеми з дистрибуцією, збої бронювання та складні звернення — як від авіакомпаній, так і від продавців."
      },
      testi: {
        slide1Quote: "Партнерство з DRCT допомагає нам надавати NDC-контент ширшій мережі продавців туристичних послуг, зберігаючи надійний і послідовний процес бронювання.",
        slide1Name: "Jane Doe",
        slide1Role: "Керівник відділу дистрибуції, Lufthansa",
        slide1ImageAlt: "Термінал аеропорту Lufthansa",
        slide2Quote: "Співпраця з DRCT допомагає нам охопити NDC-контентом ширше коло продавців туристичних послуг — без компромісів у якості сервісу, якого клієнти очікують від Emirates.",
        slide2Name: "John Smith",
        slide2Role: "Віцепрезидент зі стратегії дистрибуції, Emirates",
        slide2ImageAlt: "Пілоти Emirates в аеропорту",
        prevLabel: "Попередній відгук",
        nextLabel: "Наступний відгук"
      },
      cta: {
        title: "Готові розширити свою дистрибуцію?",
        description: "Станьте партнером DRCT як авіакомпанія або отримайте доступ як продавець туристичних послуг.",
        ctaLabel: "Запланувати демо"
      },
      faq: {
        heading: "FAQ",
        description: "Не знайшли відповіді? Зверніться до нашої служби підтримки.",
        q1: "Які авіакомпанії вже працюють з DRCT?",
        a1: "Aegean Airlines, airBaltic, American Airlines, British Airways, Brussels Airlines, Emirates, flydubai, Iberia, LOT, Lufthansa, SWISS, TAP, United Airlines та понад 40 інших авіакомпаній.",
        demoLabel: "Запросіть демо,",
        demoAfter: "щоб отримати оновлений список інтеграцій.",
        q2: "Чи є DRCT агентством із продажу авіаквитків?",
        a2: "Ні. DRCT — технологічний провайдер і агрегатор авіакомпаній. Ми не продаємо авіаквитки, а надаємо агентствам та іншим продавцям технологічне рішення для їх оформлення.",
        q3: "Чи втрачу я інсентивну угоду з авіакомпанією?",
        a3: "Ні. Усі продажі через DRCT здійснюються за вашими власними угодами з авіакомпаніями. Якщо вони передбачають інсентиви, ви їх зберігаєте.",
        q4: "Що таке NDC?",
        a4: "New Distribution Capability (NDC) — це стандарт обміну даними на основі XML. NDC дає змогу авіакомпаніям передавати дані безпосередньо агентам, минаючи застарілих посередників на кшталт GDS. Стандарт відкриває доступ до повного контенту авіакомпаній: ексклюзивних тарифів, додаткових послуг і персоналізованих пропозицій.",
        q5: "Як отримати доступ до NDC авіакомпанії?",
        a5: "Команда DRCT допомагає подати заявку на отримання доступів NDC від авіакомпанії. З’жіться з нами — і ми допоможемо почати роботу з усіма провідними авіакомпаніями нашої мережі.",
        q6: "Як почати роботу?",
        a6: "Встановлення займає лише 10 хвилин. Запросіть демо — наша команда допоможе з налаштуванням і супроводжуватиме вас протягом 30-денного безкоштовного пробного періоду.",
        q7: "Який номер офісу IATA використовується для виписки квитків?",
        a7: "Квитки виписуються під номером вашого офісу IATA. DRCT не виписує квитки — це робить ваше агентство з використанням власних доступів і розрахунків через BSP.",
        q8: "Чи можу я довіряти DRCT?",
        a8: "DRCT має сертифікацію IATA як постачальник систем Airline Retailing Maturity (ARM). Ми працюємо з понад 50 авіакомпаніями та сотнями агентств у всьому світі.",
        q9: "Як оформити повернення або обмін?",
        a9: "Повернення та обмін можна оформити безпосередньо в інтерфейсі DRCT або у звичному процесі GDS — залежно від можливостей NDC авіакомпанії.",
        q10: "Що робити, якщо в NDC авіакомпанії бракує потрібної функціональності?",
        a10: "Підтримка DRCT працює 24/7 і може передати питання безпосередньо команді NDC авіакомпанії. Ми також постійно стежимо за якістю NDC й виявляємо проблеми до того, як вони вплинуть на вашу роботу.",
        q11: "Чи можна отримати ADM під час роботи з DRCT?",
        a11: "DRCT допомагає знизити ризик отримання ADM. Наші процеси відповідають вимогам авіакомпаній і допомагають уникати дебетових нот. Ми беремо на себе ризики переходу, щоб вам не довелося цього робити.",
        q12: "Як DRCT шукає дешевші класи бронювання?",
        a12: "Після створення кожного бронювання DRCT автоматично перевіряє наявність нижчих тарифних класів NDC. Якщо до виписки квитка знайдено кращу ціну, ви отримуєте сповіщення з можливістю перерахувати тариф.",
        q13: "Чи доступні в DRCT черги?",
        a13: "Так. DRCT інтегрується з чергами вашого GDS. Ви можете відстежувати бронювання NDC разом зі звичними чергами GDS без перемикання між інтерфейсами."
      }
    },
    showAllFunctionality: "ПЕРЕГЛЯНУТИ БІЛЬШЕ",
    hideAllFunctionality: "СХОВАТИ",
    certifiedTitle: "Працюємо з",
    certifiedDescription: "Більше 40 провідних авіакомпаній вже обрали DRCT як партнера",
    live: "+30 авіакомпаній \nзапущено",
    impl: "Наразі ми інтегруємо \n+10 авіакомпаній",
    iataTitle: "ARM System Provider сертифікований IATA",
    iataDescription: "Більше інформації в реєстрі",
    iataLink: "IATA ARM індексів",
    cookiePrivacy: "політики конфіденційності",
    cookieText: "Продовжуючи користуватися цим сайтом, ви погоджуєтеся на використання файлів cookie відповідно до нашої",
    airline_advantage_1: "Інтеграція протягом 2-4 тижнів",
    airline_advantage_2: "Оплата за використання",
    airline_advantage_3: "До 86% ефективніше за ваш OBT",
    airlines: {
      pageTitle: "DRCT для авіакомпаній",
      title: "Зменшуйте витрати на дистрибуцію та ІТ-інфраструктуру. Зосередьтесь на таких важливих питаннях, як керування флотом та досвід пасажирів.",
      description: "DRCT це постачальник технологій, який створює платформу дистрибуції нової ери, подібну до Uber, яка об’єднує перевізників і пасажирів у надійну екосистему, що забезпечує унікальний досвід покупок.",
      presentationPlaceholder: "Введіть вашу електронну пошту",
      getPresentation: "Запланувати демо",
      contactSoon: "Ми з’жемось з вами протягом дня",
      whatWeDo: "Що ми робимо",
      whatWeDo1: "Скорочуємо витрати на залучення клієнтів у метапошуку та пошукових системах",
      whatWeDo2: "Допомагаємо авіакомпаніям надати цінність своєї продукції GDS і метапошуку",
      whatWeDo3: "Скорочуємо витрати на дистрибуцію до 80% через агентську мережу",
      whatWeDo4: "Надаємо персоналізовані пропозиції авіакомпаній у метапошуку та GDS",
      whatWeDo5: "Збільшуємо доходи за рахунок збільшення додаткових послуг",
    },
    privacy: {
      pageTitle: "Політика конфіденційності"
    },
    websiteTerms: {
      pageTitle: "Умови користування сайту"
    },
    extensionTerms: {
      pageTitle: "Розширені терміни користування"
    },
    communicationPolicy: {
      pageTitle: "Політика комунікації"
    },
    footerPrivacies: "Політика",
    followUs: "Підписуйтесь на нас",
    ourProducts: "Продукти"
  },
  pl: {
    landingPromotion: {
      desktop: "DRCT na World Aviation Festival w Lizbonie, 13–15 października. Odwiedź nas na stoisku 1-102C.",
      mobile: "Spotkajmy się na WAF Lisbon, 13–15 paź.",
      ctaLabel: "Więcej",
      dismissLabel: "Zamknij ogłoszenie o World Aviation Festival"
    },
    landingNavigation: {
      toggleLabel: "Otwórz lub zamknij menu",
      mainLabel: "Nawigacja główna"
    },

    apiMessage: "Rozpocznij sprzedaż biletów za pomocą API DRCT",
    apiDescription: "Zbuduj swój biznes turystyczny dzięki szybko zintegrowanemu API DRCT. Wystawiaj bilety w unikalnych cenach bez opłat GDS. Zapoznaj się z dokumentacją i wyślij pierwsze żądanie, aby rozpocząć w 5 minut.",
    advantage_api_1: "Integracja w 5 dni",
    advantage_api_2: "Żadnych płatności z góry",
    advantage_api_3: "Wsparcie 24/7",
    apiOnePlaceTitle1: "Wyszukiwanie",
    apiOnePlaceOption1: "Wszystkie niezbędne metody wyszukiwania lotów i cen są dostępne, aby uzyskać aktualne informacje. ",
    apiOnePlaceTitle2: "Rezerwacja i wystawienie",
    apiOnePlaceOption2: "Po dokonaniu rezerwacji pojawi się limit czasu. Rezerwacja powinna zostać wystawiona w dowolnym momencie przed upływem określonego terminu.",
    apiOnePlaceTitle3: "Usługi posprzedażowe",
    apiOnePlaceOption3: "Unieważnij bilety i anuluj rezerwacje. Wymiana biletów i zwroty kosztów są możliwe za pośrednictwem naszej pomocy technicznej.",
    apiOnePlaceTitle4: "Usługi dodatkowe",
    apiOnePlaceOption4: "Zamów dowolne dodatkowe usługi, od posiłków i miejsc na pokładzie po przewóz zwierząt domowych. Będą dostępne wkrótce.",
    apiOnePlaceTitle: "Wszystkie funkcje w jednej aplikacji",
    apiOnePlaceDescription: "Łączymy wszystko, co jest potrzebne do wystawienia biletu w najlepszej cenie i towarzyszymy klientowi od zakupu do wejścia na pokład",
    apiBenefitsTitle: "Przyjazny dla programistów 💙",
    apiBenefitsDescription: "API DRCT zostało stworzone z miłością dla programistów. \n Nie musisz rozumieć skomplikowanych interfejsów API linii lotniczych - zrobiliśmy to już za Ciebie.",
    apiBenefitTitle1: "Kompleksowa dokumentacja",
    apiBenefitDescription1: "Dołożyliśmy wszelkich starań, aby dokumentacja była przejrzysta i prosta. Szybko rozpocznij pracę z dokumentacją, <a target='_blank' href='https://www.postman.com/drct-api/workspace/drct-api/overview'>przestrzenią roboczą Postman</a> i stabilnym środowiskiem testowym.",
    apiBenefitTitle2: "Łatwe w użyciu narzędzie do rezerwacji",
    apiBenefitDescription2: "Pomaga upewnić się, że żądania są wysyłane poprawnie, dzięki czemu loty i utworzone rezerwacje są wyświetlane tak, jak powinny",
    apiBenefitTitle3: "Wsparcie",
    apiBenefitDescription3: "Utrzymanie dokładnych i łatwych do zrozumienia referencji API ma dla nas kluczowe znaczenie. Jeśli masz jakieś pytania lub chcesz podzielić się swoją opinią, po prostu skontaktuj się z nami na czacie.",
    pageTitle: "DRCT dla agentów",
    pageDescription: "Sprzedawaj loty i usługi dodatkowe bezpośrednio od linii lotniczymch bez opuszczania swojego GDS. Zwiększ swoje marże dzięki oprogramowaniu zorientowanemu na agentów i zerowej opłacie za wystawienie biletu.",
    forAgencies: "Dla agencji",
    forNonIataAgencies: "Dla agencji Non-IATA",
    forOta: "Dla OTA",
    forAirlines: "Dla linii lotniczych",
    forDevelopers: "Dla deweloperów",
    signIn: "Zaloguj się",
    try: "Umów demo",
    solutionsMenu: {
      label: "Rozwiązania",
      heading: "Rozwiązania",
      description: "Znajdź rozwiązanie DRCT do dystrybucji, sprzedaży lub integracji ofert linii lotniczych.",
      airlines: {
        title: "Dla linii lotniczych",
        description: "Taryfy i usługi dodatkowe bez zmian w GDS, NDC i kanałach bezpośrednich — bez utraty zasięgu wśród agentów."
      },
      iataAgencies: {
        title: "Dla biur z akredytacją IATA",
        description: "Pełna oferta w Twoich narzędziach — rezerwacje, obsługa, raportowanie BSP i wsparcie 24/7."
      },
      nonIataAgencies: {
        title: "Dla biur bez akredytacji IATA",
        description: "Bilety i obsługa od pierwszego dnia — bez IATA, umów z liniami i znajomości GDS."
      },
      ota: {
        title: "Dla OTA",
        description: "NDC, tanie linie i czartery przez jedno API — spójny format danych i limity L2B dla OTA."
      }
    },
    productsMenu: {
      label: "Produkty",
      heading: "Produkty",
      description: "Wybierz produkt DRCT do rezerwacji, integracji lub obsługi biletów.",
      workspace: {
        title: "Workspace",
        description: "Wyszukuj, rezerwuj i obsługuj pełną ofertę linii lotniczych w jednym środowisku dla Twojego biura."
      },
      api: {
        title: "API",
        description: "Jedno API dla wszystkich źródeł: spójny format, dobre ceny i wysokie limity L2B — bez wyjątków."
      },
      extension: {
        title: "Extension",
        description: "Pełne oferty linii i usługi dodatkowe w narzędziach, które już znasz — bez zmiany sposobu pracy."
      }
    },
    exploreDocs: "Poznaj dokumenty",
    airlinesMessage: "Linie lotnicze bliżej pasażerów",
    airlinesDescription: "DRCT jest dostawcą technologii budującym platformę dystrybucyjną nowej ery podobną do Ubera, aby zjednoczyć przewoźników i pasażerów w solidnym ekosystemie zapewniającym wyjątkowe wrażenia z zakupów.",
    airlinesAdvantage1: "Uruchomienie za 2-4 tygodnie",
    airlinesAdvantage2: "Tania dystrybucja",
    airlinesAdvantage3: "Wsparcie 24/7",
    airlinesCostsTitle: "Redukcja kosztów 📉",
    airlinesCostsDescription: "Celem DRCT jest ulepszenie dystrybucji linii lotniczych w bardziej wydajną — prostą, spersonalizowaną i tanią. Skupiamy się na technologii, aby linie lotnicze mogły skupić się na produkcie.",
    airlinesCostsBenefit1Title: "Dotarcie do nowych rynków i klientów",
    airlinesCostsBenefit1Desc: "Rozwój działalności na rynkach niekrajowych zawsze stanowi wyzwanie dla linii lotniczych. Zwłaszcza na rynkach, na których udział linii lotniczych w rynku jest niski. Pobieranie płatności i zawieranie umów jest kosztowne. \n \nDRCT jest zintegrowany z GDS-ami, systemami płatności i jest reprezentowany przez globalnych GSA na wszystkich głównych rynkach. Wykorzystując istniejące połączenia, umożliwiamy sprzedaż biletów za pośrednictwem GDS na dowolnym rynku i przyjmowanie płatności za pośrednictwem BSP lub karty kredytowej bez zbędnego pośpiechu i opłat GDS",
    airlinesCostsBenefit2Title: "O wspieraniu własnych OBT i API",
    airlinesCostsBenefit2Desc: "Rozwijanie i wspieranie własnych OBT jest kosztowne i nie jest skuteczne. Zmuszenie sprzedawców do korzystania z OBT różnych linii lotniczych do wyszukiwania lotów jest prawie niemożliwe. Dostarczanie i wspieranie własnego interfejsu API lub OBT jest również wyzwaniem - automaty wdrożeniowe, certyfikacja, wsparcie i zawieranie umów. Wszystko to oznacza, że linia lotnicza wydaje zasoby na personel techniczny zamiast rozwijać swoją działalność. \n \nDRCT dostarcza treści do sprzedawcy za pośrednictwem API lub OBT. Zintegrowany z setkami sprzedawców nasz zespół doskonale rozumie wymagania każdego rodzaju sprzedawcy - TMC, OTA, tradycyjnych agencji. DRCT ma już integrację z systemami mid- i back-office, więc wdrożenie rozwiązań DRCT jest najprostszym sposobem na uzyskanie treści od wszystkich potrzebnych linii lotniczych bez konieczności wdrażania OBT lub API każdej linii lotniczej",
    airlinesRevenuesTitle: "Zwiększ przychody 📈",
    airlinesRevenuesDescription: "Biznes linii lotniczych jest niskomarżowy. Wykorzystując nowoczesną technologię i dostęp do rynków, DRCT zapewnia możliwości wzrostu przychodów i marży.",
    airlinesRevenuesBenefit1Title: "Poprzez rozszerzenie sieci",
    airlinesRevenuesBenefit1Desc: "Tradycyjny model biznesowy linii lotniczych polegający na budowaniu własnej sieci i dystrybucji za pośrednictwem GDS nie jest już poszukiwany. Model punkt-punkt z bezpośrednimi kanałami dystrybucji przejmuje kontrolę. Ma on jednak również wady. Brak pasażerów tranzytowych i ograniczona dystrybucja sprawiają, że model ten jest mało skalowalny. \nDRCT jest agregatorem dla wielu linii lotniczych, jesteśmy również połączeni z większością CRS i wszystkimi GDS. Umożliwia to szybkie i łatwe nawiązywanie współpracy bez konieczności wprowadzania zmian w modelach biznesowych i strukturach cenowych. Skutecznie dostarczamy również te treści sprzedawcom na całym świecie",
    airlinesRevenuesBenefit2Title: "Korzystanie z głębokiej analizy danych i personalizacji, aby sprzedawać więcej",
    airlinesRevenuesBenefit2Desc: "Podczas dystrybucji linie lotnicze mogą uzyskać bardzo ograniczone informacje na temat zapytań o lot. W większości przypadków jest to po prostu anonimowe zapytanie o cenę i rezerwacja. Brak informacji o tym, kto pyta, oraz rzeczywiste oferty konkurencji uniemożliwiają tworzenie ofert opartych na danych. \n \nDRCT otrzymuje mnóstwo informacji bezpośrednio od sprzedawcy w momencie zapytania. W większości przypadków wiemy, kto szuka lotu, znamy historię poprzednich zakupów i oferty wszystkich linii lotniczych, które są proponowane pasażerowi. Daje nam to wyjątkową przewagę w tworzeniu spersonalizowanych ofert, które będą idealnie dopasowane do oczekiwań pasażerów",
    footerPrivacy: "Polityka prywatności",
    footerWebsiteTerms: "Warunki korzystania z witryny",
    footerExtensionTerms: "Warunki korzystania z Extension",
    home: {
      pageTitle: "DRCT — platforma agregacji i dystrybucji treści lotniczych",
      pageDescription: "DRCT łączy oferty lotnicze z GDS, NDC, kanałów bezpośrednich i tanich linii w jednej warstwie dystrybucji dla sprzedawców usług lotniczych.",
      hero: {
        title: "Dostosowujemy i aktywujemy oferty linii lotniczych dla różnych odbiorców rynku turystycznego",
      subtitle: "DRCT — jedna warstwa orkiestracji dystrybucji: od biur z akredytacją IATA po OTA i superaplikacje",
        description: "Linie lotnicze w pełni kontrolują, jak ich oferty trafiają na rynek. Sprzedawcy usług turystycznych uzyskują bezproblemowy dostęp do bezpośrednich zasobów linii lotniczych — przez NDC i inne niestandardowe modele dystrybucji — bez osobnych integracji dla każdego źródła. Agencje mogą nadal pracować w znanych procesach i interfejsach GDS. Jedna platforma łączy obie strony, bez fragmentacji.",
        ctaLabel: "Umów demo",
        chipIataAgencies: "Biura z IATA",
        chipOta: "OTA",
        chipNonIataAgencies: "Biura bez IATA",
        chipTmc: "TMC",
        chipSuperApps: "Superaplikacje",
        chipTravelTechStartups: "Startupy technologiczne w turystyce"
      },
      gain: {
        heading: "Problemy, które rozwiązujemy",
        description: "DRCT eliminuje strukturalne problemy po obu stronach dystrybucji lotniczej.",
        tabSellers: "Dla sprzedawców",
        tabAirlines: "Dla linii lotniczych",
        airlineCard1Title: "Pełna kontrola nad prezentacją oferty",
        airlineCard1Desc: "Każdy agent i OTA widzi strukturę Twojej oferty dokładnie tak, jak ją zdefiniujesz: taryfy, pakiety i usługi dodatkowe są spójne we wszystkich kanałach.",
        airlineCard2Title: "Niższe koszty w skali",
        airlineCard2Desc: "Dystrybucja bezpośrednia i stopniowe przejście na NDC obniżają koszt rezerwacji bez utraty zasięgu ani dostępu do sieci agentów.",
        airlineCard3Title: "NDC w znanych narzędziach",
        airlineCard3Desc: "Treści NDC są dostępne w interfejsach GDS, które agenci już znają. Bez nowych systemów i dodatkowych szkoleń — wdrożenie przebiega naturalnie.",
        airlineCard4Title: "Jedna warstwa dla obu kanałów",
        airlineCard4Desc: "GDS i NDC działają w jednej warstwie dystrybucji: zarządzanie, raportowanie i rozliczenia odbywają się w jednym miejscu zamiast w dwóch równoległych systemach.",
        sellerCard1Title: "Cała oferta — jedno połączenie",
        sellerCard1Desc: "Treści z GDS, NDC i bezpośrednich kanałów linii lotniczych są połączone w jedną znormalizowaną warstwę: jedna integracja i pełne pokrycie wszystkich źródeł.",
        sellerCard2Title: "Jeden proces, jeden interfejs",
        sellerCard2Desc: "Wyszukuj, rezerwuj, wystawiaj bilety i obsługuj rezerwacje ze wszystkich źródeł w jednym interfejsie — bez osobnych kont i uzgadniania formatów.",
        sellerCard3Title: "Dostęp do NDC bez barier",
        sellerCard3Desc: "Uzyskaj taryfy NDC i bezpośrednie oferty linii lotniczych bez akredytacji u każdego przewoźnika ani nowych umów — w procesach, z których już korzystasz.",
        sellerCard4Title: "Spójna obsługa po rezerwacji",
        sellerCard4Desc: "Zmiany, wymiany, zwroty i anulowania obsługujesz w jednej warstwie zamówień — według spójnych zasad dla wszystkich połączonych linii lotniczych."
      },
      flow: {
        heading: "Jak działa ekosystem",
        description: "Uporządkowany proces dystrybucji: od ofert w formie źródłowej do rozwiązań gotowych dla sprzedawców — dzięki DRCT.",
        sourceEyebrow: "Oferta linii lotniczej",
        sourceHeading: "Forma źródłowa",
        sourceItem1: "GDS",
        sourceItem2: "NDC",
        sourceItem3: "Niestandardowe modele dystrybucji",
        coreEyebrow: "Warstwa orkiestracji",
        coreHeading: "Dostosowanie. Wzbogacenie. Aktywacja.",
        pipeline1: "Normalizacja — ujednolicony format",
        pipeline2: "Wzbogacenie — pakiety, dosprzedaż i rekomendacje kontekstowe",
        pipeline3: "Realizacja — pełny cykl obsługi w NDC, dedykowanych interfejsach API i GDS",
        coreNote: "Spójna obsługa niezależnie od źródła",
        destEyebrow: "Sprzedawca",
        destHeading: "Gotowa dla sprzedawcy",
        destItem1: "Agencja",
        destItem2: "OTA, Superaplikacja",
        destItem3: "TMC",
        step1Heading: "Pełny dostęp do treści",
        step1Desc: "Pełna oferta wielu linii lotniczych z różnych źródeł, połączona w jedną warstwę dystrybucji.",
        step2Heading: "Wzbogacenie",
        step2Desc: "Oferta jest wzbogacana o dodatkowe możliwości: wirtualny interlining, taryfy markowe i usługi dodatkowe, logikę cenową i taryfową oraz integracje z systemami back-office i mid-office.",
        step3Heading: "Dopasowanie do odbiorcy",
        step3Desc: "Dostosowujemy oferty do każdego kanału dystrybucji i grupy odbiorców, aby odpowiadały potrzebom różnych sprzedawców usług turystycznych i były dla nich łatwe w użyciu.",
        step4Heading: "Szkolenia i wsparcie 24/7",
        step4Desc: "Stale wspieramy partnerów: od wdrożenia i szkoleń po pomoc operacyjną we wszystkich procesach dystrybucji."
      },
      network: {
        liveTitle: "Ponad 50 linii lotniczych w sieci",
        liveAlt: "Ponad 50 podłączonych linii lotniczych",
        moreComingTitle: "Wkrótce kolejne linie lotnicze",
        moreComingAlt: "Kolejne linie lotnicze dołączają do sieci",

        heading: "Wiodący przewoźnicy. Jedna integracja.",
        description: "Uzyskaj bezpośredni dostęp do znormalizowanych ofert wiodących linii lotniczych przez jedną integrację — z pełną ofertą, spójnymi warunkami i bez osobnych umów z każdym przewoźnikiem.",
        liveLabel: "Aktywne w sieci",
        moreComingLabel: "Wkrótce kolejne",
        certHeading: "Dostawca systemu ARM certyfikowany przez IATA",
        certDescriptionBefore: "Więcej informacji w",
        certLinkLabel: "rejestrze IATA ARM"
      },
      metrics: {
        title: "DRCT w liczbach",
        value1: "50",
        suffix1: "+",
        label1: "Linie lotnicze w sieci",
        desc1: "Przewoźnicy tradycyjni i niskokosztowi aktywni w sieci.",
        value2: "4 000",
        suffix2: "+",
        label2: "Sprzedawcy usług turystycznych",
        desc2: "Agenci z TMC, OTA i partnerów API na całym świecie.",
        value3: "500",
        suffix3: "+",
        label3: "Agencje partnerskie",
        desc3: "TMC, OTA i biura podróży w Europie, Wielkiej Brytanii i USA."
      },
      why: {
        heading: "Dlaczego DRCT",
        description: "Korzyści z jednej platformy dystrybucji linii lotniczych — w prostych słowach.",
        item1Title: "GDS i NDC na jednej platformie",
        item1Desc: "Dystrybucja hybrydowa bez zarządzania dwoma równoległymi systemami. Treści NDC i GDS są połączone i spójnie dostarczane każdemu sprzedawcy.",
        item2Title: "Bez przełączania między systemami",
        item2Desc: "Linie lotnicze zarządzają dystrybucją, a sprzedawcy rezerwują, wprowadzają zmiany i obsługują zamówienia w jednym miejscu. Cały proces odbywa się na platformie DRCT.",
        item3Title: "Więcej niż tradycyjny agregator linii lotniczych",
        item3Desc: "DRCT wzbogaca oferty: dodaje usługi dodatkowe, tworzy pakiety i łączy loty różnych linii w jedną trasę. Sprzedawca otrzymuje pełniejszą ofertę niż w źródłowym kanale przewoźnika.",
        item4Title: "Dostęp do NDC bez barier",
        item4Desc: "Sprzedawcy otrzymują taryfy NDC i treści linii lotniczych w znanych interfejsach. Bez nowej akredytacji i osobnego wdrożenia NDC dla każdej linii lotniczej.",
        item5Title: "Płynne przejście bez zakłóceń",
        item5Desc: "Linie lotnicze przechodzące z GDS na NDC używają DRCT, aby robić to stopniowo — zachowując pełny zasięg i zwiększając wolumen kanału bezpośredniego.",
        item6Title: "Obsługujemy każdy typ sprzedawcy",
        item6Desc: "Agencje IATA, agenci bez akredytacji IATA, OTA, TMC i superaplikacje — wszystkich łączy ta sama platforma dystrybucji.",
        wideTitle: "Wsparcie operacyjne 24/7",
        wideDesc: "Własny zespół DRCT obsługuje problemy z dystrybucją, błędy rezerwacji i eskalacje — zarówno dla linii lotniczych, jak i sprzedawców."
      },
      testi: {
        slide1Quote: "Współpraca z DRCT pozwala nam docierać z ofertą NDC do szerszej sieci sprzedawców usług turystycznych, a jednocześnie utrzymywać spójny i niezawodny proces rezerwacji.",
        slide1Name: "Jane Doe",
        slide1Role: "Dyrektor ds. dystrybucji, Lufthansa",
        slide1ImageAlt: "Terminal lotniska Lufthansa",
        slide2Quote: "Dzięki DRCT docieramy z ofertą NDC do szerszego grona sprzedawców usług turystycznych — bez kompromisów w jakości obsługi, której klienci oczekują od Emirates.",
        slide2Name: "John Smith",
        slide2Role: "Wiceprezes ds. strategii dystrybucji, Emirates",
        slide2ImageAlt: "Piloci Emirates na lotnisku",
        prevLabel: "Poprzednia opinia",
        nextLabel: "Następna opinia"
      },
      cta: {
        title: "Chcesz rozwinąć swoją dystrybucję?",
        description: "Zostań partnerem DRCT jako linia lotnicza albo uzyskaj dostęp jako sprzedawca usług turystycznych.",
        ctaLabel: "Umów demo"
      },
      faq: {
        heading: "FAQ",
        description: "Nie znalazłeś odpowiedzi? Skontaktuj się z naszym zespołem wsparcia.",
        q1: "Które linie lotnicze już współpracują z DRCT?",
        a1: "Aegean Airlines, airBaltic, American Airlines, British Airways, Brussels Airlines, Emirates, flydubai, Iberia, LOT, Lufthansa, SWISS, TAP, United Airlines i ponad 40 innych linii lotniczych.",
        demoLabel: "Umów demo",
        demoAfter: "aby otrzymać aktualną listę integracji.",
        q2: "Czy DRCT jest agencją biletową?",
        a2: "Nie. DRCT jest dostawcą technologii i agregatorem linii lotniczych. Nie sprzedajemy biletów lotniczych, lecz zapewniamy agencjom i innym sprzedawcom rozwiązanie technologiczne do ich wystawiania.",
        q3: "Czy stracę swoją umowę motywacyjną z linią lotniczą?",
        a3: "Nie. Sprzedaż przez DRCT odbywa się na podstawie Twoich własnych umów z liniami lotniczymi. Jeśli przewidują dodatkowe wynagrodzenie, zachowujesz je.",
        q4: "Czym jest NDC?",
        a4: "New Distribution Capabilities (NDC) to oparty na XML standard wymiany danych. Umożliwia liniom lotniczym przekazywanie danych bezpośrednio agentom, z pominięciem przestarzałych pośredników, takich jak GDS. Zapewnia dostęp do pełnej oferty linii lotniczych, w tym ekskluzywnych taryf, usług dodatkowych i spersonalizowanych ofert.",
        q5: "Jak uzyskać dane dostępowe NDC od linii lotniczej?",
        a5: "Zespół DRCT pomaga złożyć wniosek o dane dostępowe NDC. Skontaktuj się z nami, a pomożemy Ci rozpocząć pracę ze wszystkimi głównymi liniami lotniczymi w naszej sieci.",
        q6: "Jak zacząć pracę?",
        a6: "Instalacja trwa tylko 10 minut. Zapytaj o demo, a nasz zespół pomoże Ci w konfiguracji i przeprowadzi Cię przez 30-dniowy bezpłatny okres próbny.",
        q7: "Który numer biura IATA jest używany do wystawiania biletów?",
        a7: "Bilety są wystawiane pod numerem Twojego biura IATA. DRCT nie wystawia biletów — robi to Twoja agencja, korzystając z własnych danych dostępowych i rozliczeń BSP.",
        q8: "Czy mogę zaufać DRCT?",
        a8: "DRCT jest certyfikowany przez IATA jako dostawca systemów Airline Retailing Maturity (ARM). Współpracujemy z ponad 50 liniami lotniczymi i setkami agencji na całym świecie.",
        q9: "Jak dokonać zwrotu lub wymiany?",
        a9: "Zwrot lub wymianę możesz obsłużyć bezpośrednio w interfejsie DRCT albo w swoim procesie GDS — zależnie od możliwości NDC danej linii lotniczej.",
        q10: "Co zrobić, jeśli NDC mojej linii lotniczej ma ograniczoną funkcjonalność?",
        a10: "Nasz zespół wsparcia zapewnia pomoc 24/7 i może eskalować sprawę bezpośrednio do zespołu NDC linii lotniczej. Proaktywnie monitorujemy również jakość NDC i wykrywamy problemy, zanim wpłyną na Twoją pracę.",
        q11: "Czy podczas korzystania z DRCT mogę otrzymać ADM?",
        a11: "DRCT chroni przed ADM. Nasze procesy spełniają wymagania linii lotniczych i pomagają unikać not debetowych. Bierzemy na siebie ryzyko migracji, abyś Ty nie musiał.",
        q12: "Jak działa wyszukiwanie tańszych klas rezerwacyjnych?",
        a12: "Po dokonaniu każdej rezerwacji DRCT automatycznie sprawdza dostępność niższych klas taryfowych NDC. Jeśli przed wystawieniem biletu znajdziemy lepszą cenę, otrzymasz powiadomienie z możliwością ponownego przeliczenia taryfy.",
        q13: "Czy kolejki są dostępne w DRCT?",
        a13: "Tak. DRCT integruje się z kolejkami w Twoim GDS. Rezerwacje NDC możesz monitorować razem ze zwykłymi kolejkami GDS, bez przełączania się między interfejsami."
      }
    },
    showAllFunctionality: "WYŚWIETL WIĘCEJ",
    hideAllFunctionality: "UKRYJ",
    certifiedTitle: "Pracujemy z",
    certifiedDescription: "Ponad 40 wiodących linii lotniczych, które już wybrały DRCT jako partnera.",
    live: "+30 linii lotniczych \nuruchomiony",
    impl: "Obecnie integrujemy \n+10 linii lotniczych",
    iataTitle: "ARM System Provider certyfikowany przez IATA",
    iataDescription: "Więcej informacje w",
    iataLink: "IATA ARM rejestrze",
    cookiePrivacy: "Polityka prywatności",
    cookieText: "Kontynuując korzystanie z tej witryny, użytkownik wyraża zgodę na korzystanie z plików cookie zgodnie z naszą polityką prywatności.",
    airline_advantage_1: "Integracja w ciągu 2-4 tygodni",
    airline_advantage_2: "Płać za to, z czego korzystasz",
    airline_advantage_3: "Do 86% większa wydajność niż w przypadku OBT",
    airlines: {
      pageTitle: "DRCT dla linii lotniczych",
      title: "Obniż koszty dystrybucji i infrastruktury IT. Skoncentruj się na tym, co ważne, na przykład na operacjach floty i doświadczeniach pasażerów",
      description: "DRCT jest dostawcą technologii budującym platformę dystrybucyjną nowej ery podobną do Ubera, aby zjednoczyć przewoźników i pasażerów w solidnym ekosystemie zapewniającym wyjątkowe wrażenia z zakupów.",
      presentationPlaceholder: "Wprowadź swój e-mail",
      getPresentation: "Umów demo",
      contactSoon: "Skontaktujemy się z Tobą w ciągu dnia",
      whatWeDo: "Co robimy",
      whatWeDo1: "Obniżanie kosztów pozyskiwania klientów w metasearch i wyszukiwarkach",
      whatWeDo2: "Pomaganie liniom lotniczym w dostarczaniu wartości ich produktów do GDS i metasearch",
      whatWeDo3: "Obniżenie kosztów dystrybucji do 80% za pośrednictwem sieci agentów",
      whatWeDo4: "Dostarczanie liniom lotniczym spersonalizowanych ofert w metawyszukiwarkach i GSD",
      whatWeDo5: "Zwiększenie przychodów poprzez zwiększenie sprzedaży dodatkowej",
    },
    privacy: {
      pageTitle: "Polityka prywatności"
    },
    websiteTerms: {
      pageTitle: "Warunki korzystania z witryny"
    },
    extensionTerms: {
      pageTitle: "Warunki użytkowania rozszerzenia"
    },
    communicationPolicy: {
      pageTitle: "Polityka komunikacji"
    },
    footerPrivacies: "Polityka",
    followUs: "Śledź nas",
    ourProducts: "Produkty"
  }
}
